import React from "react"

import {
  TextInput,
} from "./Form"

export default props => {
  return (
    <div>
      <h2 className="text-center">Guest Name (optional)</h2>

      <div className="text-center delivery_address">
        Enter the walk-in group or guest's name for this order. This appears
        on the packing slip alongside the table's default guest name — it
        does not change the table's saved guest record.
      </div>

      <div>
        <TextInput
          label="Guest Name"
          id="guest_override_name"
          errors={props.order.errors['guest_override_name']}
          wrapperHTMLClassName="col-sm-6"
          defaultValue={props.order.guestOverrideName}
          name="order[guest_override_name]"
      />
      </div>
    </div>
  )
}
